export default {
	chufadimudidi: 'Origin/Destination',
	xiugaisouxun: 'Refine Search',
	you: 'From',
	xianshi: 'Showing',
	jieguo: 'results',
	paixufangshi: 'Sort by',
	zuipianyi: 'Cheapest',
	zuikuai: 'Quickest',
	tuiguang: 'Recommended',
	tingzhan: 'Stops',
	tingzhanyi: 'Stop',
	zhifei: 'Direct(Non-stop)',
	yigetingzhan: '1 Stop',
	duoguoliangge: '≥2 Stops',
	meiyouchangshijian: 'No long layovers',
	shaoyusixiaoshi: 'less than 4 hours',
	jiagefanwei: 'Price Range',
	hanshui: 'Tax Inclusive',
	hangbanshikebiao: 'Flight Schedule',
	tingliushijian: 'Durations',
	tingliu: 'Durations',
	hangkonggongsi: 'Airlines ',
	lianmeng: 'Alliances',
	jiebo: 'Connections',
	zongjia: 'Total Amount',
	xianzaiyuding: 'Book Now',
	chakantanpai: 'View CO2',
	shengyu: '',
	gezuowei: 'Seats Left',
	zongfeixingshijian: 'Total Duration',
	feixingshijian: 'Flight Time',
	hangbanxiangxixinxi: 'Flight Detail',
	xianshigengduo: 'Show More',
	quanxuan: 'Select All',
	qingchu: 'Clear',
	xuanzenindefukuanfangshi: 'Choose Your Payment Method',
	xinyongkajiejika: 'Credit Card',
	qingshurunindexiangxixinxi: 'Please enter your credit card details',
	youxiaoriqi: 'Expiry Date',
	xinyongkajiejikakahao: 'Card Number',
	kayanzhengma: 'Card Verification Number',
	yanzhengmatishi: 'Three-Digit Card Validation Code (CVC2) code appears on the signature panel or on a white box to the right of the signature panel on the back of the card.',
	dianziyoujian: 'Email Address (optional)',
	lijifukuan: 'Pay Now',
	quxiaobingfanhui: 'Cancel and Return',
	wuxiaoka: 'Invalid Card',
	yichang: "Abnormal Status,Please contact bank customer service to resolve the issue",
	jiagefashengbiandong: 'Price has changed, we are currently re checking flights',
	ren: 'passenger',
	chengkepingjunjiage: 'Avg price per passenger',
};
